import { Directive, ElementRef, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[textWithLink]',
    standalone: true,
})
export class TextWithLinkDirective implements OnInit {
    @Output() textWithLink: EventEmitter<void> = new EventEmitter<void>();

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    public ngOnInit(): void {
        const customLink = this.el.nativeElement.querySelector('.custom-link');

        if (customLink) {
            this.renderer.addClass(customLink, 'link');
            this.renderer.listen(customLink, 'click', () => {
                this.textWithLink.emit();
            });
        } else {
            console.error('No custom link exists !');
        }
    }
}
